import { Link } from "react-router-dom";
const MobileResetPasswordForm = ({
	form,
	onSubmit,
	password,
	confirmPassword,
}) => {
	const { register, handleSubmit, formState, setPassword, setConfirmPassword } =
		form;
	return (
		<form
			onSubmit={handleSubmit(onSubmit)}
			className="flex flex-col gap-[16px]"
		>
			<div className="w-full flex flex-col gap-[16px]">
				{/* New Password */}
				<div className="relative h-[40px]">
					<div className="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
						<img
							src="/assets/verify-otp/img.svg"
							alt="icon"
							className="w-4 h-4"
						/>
					</div>
					<input
						id="mobile-verification-code"
						type="password"
						{...register("password")}
						placeholder="New Password"
						className="no-spinner w-full h-full rounded-[8px] border border-[#193D34] pl-8 pr-10 p-[8px] outline-none"
					/>
					{password && (
						<button
							type="button"
							onClick={() => setPassword("password", "")}
							className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-800"
						>
							×
						</button>
					)}
				</div>
				{formState.errors.password && (
					<p className="text-red-500 text-sm mt-1">
						{formState.errors.password.message}
					</p>
				)}
				{/* Confirm Password */}
				<div className="relative h-[40px]">
					<div className="absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none">
						<img
							src="/assets/verify-otp/img.svg"
							alt="icon"
							className="w-4 h-4"
						/>
					</div>
					<input
						id="mobile-confirm-password"
						type="password"
						{...register("confirmPassword")}
						placeholder="Confirm Password"
						className="no-spinner w-full h-full rounded-[8px] border border-[#193D34] pl-8 pr-10 p-[8px] outline-none"
					/>
					{confirmPassword && (
						<button
							type="button"
							onClick={() => setConfirmPassword("")}
							className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-800"
						>
							×
						</button>
					)}
				</div>
				{formState.errors.confirmPassword && (
					<p className="text-red-500 text-sm mt-1">
						{formState.errors.confirmPassword.message}
					</p>
				)}
			</div>

			{/* Submit + Support */}
			<div className="w-full h-[82px] flex flex-col items-center justify-center mx-auto gap-[16px] mt-[40px]">
				<button className="w-full h-[32px] flex items-center justify-center rounded-[24px] p-[8px] bg-deepForest text-white text-[13px] font-[500] font-montserrat leading-[24px] text-center">
					Change Password
				</button>
			</div>
		</form>
	);
};

export default MobileResetPasswordForm;
